import api from './api';

const applicationService = {
  // Apply for a job (Candidate)
  applyForJob: async (applicationData) => {
    const response = await api.post('/applications', applicationData);
    return response;
  },

  // Get my applications (Candidate)
  getMyApplications: async (params = {}) => {
    const response = await api.get('/applications/my-applications', { params });
    return response;
  },

  // Get my application statistics (Candidate)
  getMyStats: async () => {
    const response = await api.get('/applications/my-stats');
    return response;
  },

  // Withdraw application (Candidate)
  withdrawApplication: async (id) => {
    const response = await api.delete(`/applications/${id}`);
    return response;
  },

  // Get single application
  getApplicationById: async (id) => {
    const response = await api.get(`/applications/${id}`);
    return response;
  },

  // Get applications for a job (Employer)
  getJobApplications: async (jobId, params = {}) => {
    const response = await api.get(`/applications/job/${jobId}`, { params });
    return response;
  },

  // Get all applications for all jobs (Employer)
  getEmployerApplications: async () => {
    const response = await api.get(`/applications/job`);
    return response;
  },

  // Get employer statistics (Employer)
  getEmployerStats: async () => {
    const response = await api.get('/applications/employer-stats');
    return response;
  },

  // Update application status (Employer)
  updateApplicationStatus: async (id, status, notes = '') => {
    const response = await api.patch(`/applications/${id}/status`, { status, notes });
    return response;
  },

  // Schedule interview (Employer)
  scheduleInterview: async (id, interviewData) => {
    const response = await api.post(`/applications/${id}/interview`, interviewData);
    return response;
  },

  // Check if candidate already applied for a job
  checkIfApplied: async (jobId) => {
    const response = await api.get(`/applications/check/${jobId}`);
    return response;
  },

  // Get all applications (Admin)
  getAllApplications: async (params = {}) => {
    const response = await api.get('/applications', { params });
    return response;
  }
};

export default applicationService;
